module.exports = __webpack_public_path__ + "img/logo-adata.1e61cda1.svg";